import EngineWidgetModal from './engine-widget-modal';


export default class EngineWidgetRooms extends EngineWidgetModal {
    _prepareInitialData() {
        return {
            ...super._prepareInitialData(),
            roomCode: this._trigger.dataset.codigo
        };
    }
}
